import React from 'react'
import { Toggle, Row } from '@fs/zion-ui'
import SettingsToggleDescription from './SettingsToggleDescription'

const SettingsToggle = ({ label, description, checked, disabled, onChange, id }) => {
  const labelId = `${id}-label`
  const descriptionId = description ? `${id}-description` : ''
  return (
    <Row alignY="top" gutters="xxs">
      <Toggle
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange({ id, checked: e.target.checked, event: e })}
        aria-labelledby={labelId}
        aria-describedby={descriptionId}
        noShrinkX
      />
      <SettingsToggleDescription
        label={<span id={labelId}>{label}</span>}
        description={description && <span id={descriptionId}>{description}</span>}
        toggleId={id}
      />
    </Row>
  )
}

export default SettingsToggle
